import {MRT_Localization} from "material-react-table";
import {MRT_Localization_EN} from "material-react-table/locales/en";
import {MRT_Localization_NL} from "material-react-table/locales/nl";
import {MRT_Localization_FR} from "material-react-table/locales/fr";
import {MRT_Localization_ES} from "material-react-table/locales/es";
import {MRT_Localization_DE} from "material-react-table/locales/de";
import {MRT_Localization_IT} from "material-react-table/locales/it";
import {MRT_Localization_AR} from "material-react-table/locales/ar";
import {MRT_Localization_HI} from "../assets/i18n/materialReactTableTranslations";
import {MRT_Localization_PT} from "material-react-table/locales/pt";
import {LanguageType} from "../types/domain/languageType";
import {MeasureSystemType} from "../types/domain/measureSystemType";
import {User, UserPreferences} from "../types/domain/user";
import {DateFormatType} from "../types/domain/dateFormat";

export const getUserFullName = (user: User) => `${user.properties.firstName} ${user.properties.lastName}`;

export const DEFAULT_USER_PREFERENCES: Required<UserPreferences> = {
    enabledMarketingEmails: false,
    language: LanguageType.ENGLISH,
    measureSystem: MeasureSystemType.METRIC,
    enabledAdvancedFeatures: false,
    enabledFieldAlerts: false,
    enabledUiHelp: true,
    dateFormat: DateFormatType.EU,
};

export const validateUserPasswordRequirements = (password: string) =>
    password.length >= 8 &&
    /[A-Z]/.test(password) &&
    /[a-z]/.test(password) &&
    /[0-9]/.test(password) &&
    /[^A-Za-z0-9]/.test(password);

export function languageTypeToLocale(language?: LanguageType): string {
    switch (language) {
        case LanguageType.NEDERLANDS:
            return "nl";
        case LanguageType.FRANCAIS:
            return "fr";
        case LanguageType.ESPANOL:
            return "es";
        case LanguageType.DEUTSCH:
            return "de";
        case LanguageType.ITALIANO:
            return "it";
        case LanguageType.ARABIC:
            return "ar";
        case LanguageType.HINDI:
            return "hi";
        case LanguageType.PORTUGUESE:
            return "pt";
        default:
            return "en";
    }
}

export function languageTypeToTableLocale(language?: LanguageType): MRT_Localization {
    switch (language) {
        case LanguageType.NEDERLANDS:
            return MRT_Localization_NL;
        case LanguageType.FRANCAIS:
            return MRT_Localization_FR;
        case LanguageType.ESPANOL:
            return MRT_Localization_ES;
        case LanguageType.DEUTSCH:
            return MRT_Localization_DE;
        case LanguageType.ITALIANO:
            return MRT_Localization_IT;
        case LanguageType.ARABIC:
            return MRT_Localization_AR;
        case LanguageType.HINDI:
            return MRT_Localization_HI;
        case LanguageType.PORTUGUESE:
            return MRT_Localization_PT;
        default:
            return MRT_Localization_EN;
    }
}
